import { TabStatus } from "../models/TabSessionStorage";

export enum TabSessionStorageDispatchTypes {
  SET_TAB_DATA_INVOKE = "SET_TAB_DATA_INVOKE",
  SET_TAB_DATA_SUCCESS = "SET_TAB_DATA_SUCCESS",
  SET_TAB_DATA_RESET = "SET_TAB_DATA_RESET",
}

export enum TabSessionStorageReAuthDispatchTypes {
  SET_TAB_DATA_RE_AUTH_INVOKE = "SET_TAB_DATA_RE_AUTH_INVOKE",
  SET_TAB_DATA_RE_AUTH_SUCCESS = "SET_TAB_DATA_RE_AUTH_SUCCESS",
  SET_TAB_DATA_RE_AUTH_RESET = "SET_TAB_DATA_RE_AUTH_RESET",
}

export const tabStatus: TabStatus[] = [
  { tabIndex: 0, isVisited: true, label: "Agency Details" },
  { tabIndex: 1, isVisited: false, label: "Referral Source" },
  { tabIndex: 2, isVisited: false, label: "Physician Detail" },
  { tabIndex: 3, isVisited: false, label: "ICD 10" },
  { tabIndex: 4, isVisited: false, label: "Request Service" },
  { tabIndex: 5, isVisited: false, label: "Document Upload" },
  { tabIndex: 6, isVisited: true, label: "Review" },
];

export const updateTabStatus = (
  currentTabIndex: number,
  statusArray: TabStatus[]
) => {
  const currentTabStatus = statusArray || [];
  const updatedTabStatus = currentTabStatus.map(
    (tab: TabStatus, index: number) => {
      if (index === currentTabIndex) {
        return {
          ...tab,
          isVisited: true,
        };
      }
      return tab;
    }
  );
  return updatedTabStatus;
};

export const reAuthTabStatus: TabStatus[] = [
  { tabIndex: 0, isVisited: true, label: "Agency Details" },
  { tabIndex: 1, isVisited: false, label: "Physician Details" },
  { tabIndex: 2, isVisited: false, label: "ICD 10" },
  { tabIndex: 3, isVisited: false, label: "Request Service" },
  { tabIndex: 4, isVisited: false, label: "Document Upload" },
  { tabIndex: 5, isVisited: true, label: "Review" },
];
